import { CircleCheck } from "lucide-react";

function FeatureList({ feature }: Readonly<{ feature: string }>) {
  return (
    <li className="feature-list">
      <CircleCheck color="#6e7ce6" size={16} /> {feature}
    </li>
  );
}

export default FeatureList;
